<script lang="ts" setup>
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
import { cn } from '@/helpers/tailwind-helpers';
import SearchInput from '@/molecules/SearchInput.vue';

export type BottomButtonsProps = {
  type?: 'vertical' | 'horizontal';
  showSearchBar?: boolean;
  fixed?: boolean;
  searchPlaceholder?: string;
  searchId?: string;
  class?: string;
};

const props = withDefaults(defineProps<BottomButtonsProps>(), {
  type: 'vertical',
  showSearchBar: false,
  fixed: false,
  searchPlaceholder: 'Rechercher',
  searchId: 'bottom-buttons-search',
});

const searchValue = defineModel<string>('searchValue');

const containerClass = cva('w-full inline-flex flex-col justify-start items-start', {
  variants: {
    fixed: {
      true: 'fixed bottom-0 left-0 right-0 bg-gradient-to-l from-white to-white/0 backdrop-blur-[10px]',
      false: 'bg-transparent',
    },
  },
  defaultVariants: {
    fixed: false,
  },
});

const contentClass = cva(
  'self-stretch flex flex-col justify-start items-start gap-2 overflow-hidden',
  {
    variants: {
      fixed: {
        true: 'p-4 pb-safe-ios',
        false: 'px-4 pb-4',
      },
    },
    defaultVariants: {
      fixed: false,
    },
  },
);

const buttonsContainerClass = computed(() => [
  props.type === 'horizontal'
    ? 'inline-flex justify-start items-center gap-2'
    : 'flex flex-col gap-2',
  'self-stretch',
]);

const computedContainerClass = computed(() =>
  cn(containerClass({ fixed: props.fixed }), props.class),
);

const computedContentClass = computed(() => contentClass({ fixed: props.fixed }));
</script>

<template>
  <div :class="computedContainerClass">
    <div :class="computedContentClass">
      <SearchInput
        v-if="showSearchBar"
        :id="searchId"
        v-model="searchValue"
        :placeholder="searchPlaceholder"
        class="self-stretch"
      />

      <div :class="buttonsContainerClass">
        <slot />
      </div>
    </div>
  </div>
</template>
